// app/features/mediaDisplaySettings/mediaDisplaySettingsSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { MediaDisplaySetting } from "../context";

interface MediaDisplaySettingsState {
  data: MediaDisplaySetting[] | null;
  loading: boolean;
  error: string | null;
}

const initialState: MediaDisplaySettingsState = {
  data: null,
  loading: false,
  error: null,
};

const mediaDisplaySettingsSlice = createSlice({
  name: "mediaDisplaySettings",
  initialState,
  reducers: {
    fetchMediaDisplaySettingsStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchMediaDisplaySettingsSuccess(
      state,
      action: PayloadAction<MediaDisplaySetting[]>,
    ) {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchMediaDisplaySettingsFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    updateMediaDisplaySetting(
      state,
      action: PayloadAction<{ id: number; is_display: boolean }>,
    ) {
      if (state.data) {
        const settingToUpdate = state.data.find(
          (setting) => setting.media_display_setting.id === action.payload.id,
        );
        if (settingToUpdate) {
          settingToUpdate.media_display_setting.is_display =
            action.payload.is_display;
        }
      }
    },
  },
});

export const {
  fetchMediaDisplaySettingsStart,
  fetchMediaDisplaySettingsSuccess,
  fetchMediaDisplaySettingsFailure,
  updateMediaDisplaySetting,
} = mediaDisplaySettingsSlice.actions;

export default mediaDisplaySettingsSlice.reducer;
